import React from 'react';
import { Box, Typography, Container, Grid, Paper, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import InfoIcon from '@mui/icons-material/Info';
import GroupsIcon from '@mui/icons-material/Groups';
import FavoriteIcon from '@mui/icons-material/Favorite';

const AboutUs = () => {
  const deepGolden = "#B8860B";
  const softSaffron = "#FFF5E1";

  // अ‍ॅनिमेशन व्हेरिएंट्स
  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  const cards = [
    {
      icon: <InfoIcon sx={{ fontSize: 40, color: deepGolden }} />,
      title: "आमचा उद्देश",
      desc: "प्रत्येक घराघरात शुद्ध जैन भक्ती आणि संस्कार पोहोचवणे हा आमचा मुख्य उद्देश आहे."
    },
    {
      icon: <FavoriteIcon sx={{ fontSize: 40, color: '#E91E63' }} />,
      title: "आमची भक्ती",
      desc: "स्तवन, पूजा आणि मंत्रांच्या माध्यमातून मनाला शांती आणि आध्यात्मिक प्रगती मिळवून देणे."
    },
    {
      icon: <GroupsIcon sx={{ fontSize: 40, color: '#1976D2' }} />,
      title: "आमचा परिवार",
      desc: "हजारो भाविक आमच्याशी जोडले गेले आहेत, जे दैनंदिन स्वाध्याय आणि भक्तीमध्ये सहभागी होतात."
    }
  ];

  return (
    <Box sx={{ 
      py: { xs: 8, md: 12 }, 
      background: `linear-gradient(180deg, #FFFFFF 0%, ${softSaffron} 100%)`,
      overflow: 'hidden' 
    }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          
          {/* --- LEFT SIDE: TEXT CONTENT --- */}
          <Grid item xs={12} md={6}>
            <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeIn}>
              <Typography 
                variant="overline" 
                sx={{ color: deepGolden, fontWeight: 800, letterSpacing: 2, display: 'block', mb: 1 }}
              >
                आमच्या विषयी माहिती
              </Typography>
              <Typography 
                variant="h2" 
                sx={{ 
                  fontWeight: 900, 
                  fontFamily: "'Playfair Display', serif", 
                  color: '#333',
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  lineHeight: 1.2,
                  mb: 3
                }}
              >
                जिनभक्ती: एक <span style={{ color: deepGolden }}>आध्यात्मिक</span> प्रवास
              </Typography>
              <Typography 
                variant="body1" 
                sx={{ color: '#555', fontSize: '1.1rem', lineHeight: 1.8, mb: 4 }}
              >
                'जिनभक्ती' हे केवळ एक व्यासपीठ नसून तो एक भक्तीचा मार्ग आहे. आम्ही जैन धर्मातील अमूल्य वारसा, पूजाविधी, आणि सुमधुर भक्ती संगीत आधुनिक तंत्रज्ञानाच्या मदतीने जगासमोर आणत आहोत. आमचा विश्वास आहे की, शुद्ध भक्ती आणि योग्य ज्ञानामुळेच मानवी जीवन सुसह्य आणि आनंदी होऊ शकते.
              </Typography>
            </motion.div>
          </Grid>

          {/* --- RIGHT SIDE: ANIMATED CARDS --- */}
          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              {cards.map((card, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.2, duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  <Paper 
                    elevation={0}
                    sx={{ 
                      p: 3, 
                      borderRadius: '20px', 
                      display: 'flex', 
                      alignItems: 'center',
                      gap: 3,
                      background: 'rgba(255, 255, 255, 0.7)',
                      backdropFilter: 'blur(10px)',
                      border: '1px solid rgba(255, 255, 255, 0.5)',
                      boxShadow: '0 10px 30px rgba(184, 134, 11, 0.05)',
                      transition: '0.3s',
                      '&:hover': { transform: 'scale(1.02)', boxShadow: '0 15px 40px rgba(0,0,0,0.1)' }
                    }}
                  >
                    <Box sx={{ p: 1.5, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                      {card.icon}
                    </Box>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#333' }}>{card.title}</Typography>
                      <Typography variant="body2" sx={{ color: '#666' }}>{card.desc}</Typography>
                    </Box>
                  </Paper>
                </motion.div>
              ))}
            </Stack>
          </Grid>

        </Grid>
      </Container>

      {/* --- BACKGROUND ELEMENT (STILL OM) --- */}
      <Box 
        sx={{
          position: 'absolute',
          left: '-5%',
          bottom: '10%',
          opacity: 0.03,
          fontSize: '400px',
          fontWeight: 900,
          zIndex: 0,
          pointerEvents: 'none',
          display: { xs: 'none', md: 'block' }
        }}
      >
        ॐ
      </Box>
    </Box>
  );
};

export default AboutUs;